import { useMessageContext } from 'stream-chat-react';
import { makeStyles } from '@material-ui/styles';
import { MessageDeletedLine, Theme } from '@bizzabo/design-system';
import ReplyButton from '../ReplyButton';
import ReplyAvatarList from '../ReplyAvatarList';

const MessageDeleted = ({ title }) => {
    const classes = useStyles();
    const { message, threadList } = useMessageContext();
    return (
        <div>
            <div className={classes.deletedMessageContentContainer}>
                <MessageDeletedLine />
                <div className={classes.deletedMessageContent}>
                    This message was deleted by the host
                </div>
            </div>
            {message.reply_count > 0 && !threadList && (
                <div className={classes.replyContainer}>
                    <ReplyAvatarList />
                    <ReplyButton title={title} />
                </div>
            )}
        </div>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        deletedMessageContentContainer: {
            display: 'flex',
            color: theme.palette.greys['500'],
        },
        deletedMessageContent: {
            'font-style': 'italic',
            'font-size': '14px',
            marginLeft: 4,
        },
        replyContainer: {
            display: 'flex',
            marginTop: 8,
        },
    }),
    { classNamePrefix: MessageDeleted.name }
);

export default MessageDeleted;
